import { render, staticRenderFns } from "./FeedbackItemV2.vue?vue&type=template&id=780b7235&scoped=true"
import script from "./FeedbackItemV2.vue?vue&type=script&lang=js"
export * from "./FeedbackItemV2.vue?vue&type=script&lang=js"
import style0 from "./FeedbackItemV2.vue?vue&type=style&index=0&id=780b7235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780b7235",
  null
  
)

export default component.exports